import React, { FC, useContext, useEffect, useState } from "react";
import { BodyClassContext } from "context/bodyClass";
import cx from "classnames";
import st from "./index.module.scss";

const TimeLocation: FC<{ isSticky: boolean }> = ({ isSticky }) => {
  const [currTime, setCurrTime] = useState<string>("");
  const [hourDegree, setHourDegree] = useState<number>(0);
  const { bodyClass } = useContext(BodyClassContext);

  const isDark = !isSticky && bodyClass.includes("whitebg");

  useEffect(() => {
    function setDate() {
      const now = new Date();
      const mins = now.getMinutes();
      const hour = now.getHours();
      const hourDegrees = (hour / 12) * 360 + (mins / 60) * 30 + 90;
      setHourDegree(hourDegrees);

      const dt = new Date();
      const time =
        dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
      setCurrTime(time);
    }

    const interval = setInterval(setDate, 1000);

    setDate();

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={cx(st.timeLocation, isDark && st.dark)}>
      <div className={cx(st.time, isDark && st.dark)}>
        <div className={cx(st.clock, isDark && st.dark)}>
          <div>
            <div
              className={cx(st.hand, isDark && st.dark, st.hourHand)}
              style={{ transform: `rotate(${hourDegree}deg)` }}
            ></div>
          </div>
        </div>
        {/* 10:56:0 */}
        {currTime}
      </div>
    </div>
  );
};

export default TimeLocation;
